import axios, { AxiosError } from 'axios';

interface RecaptchaResponse {
  success: boolean;
  challenge_ts?: string;
  hostname?: string;
  'error-codes'?: string[];
}

interface RespuestaVerificarCaptcha {
  error: boolean;
  mensaje: string;
  captchaVerificado: boolean;
}

async function VerificarCaptcha(captchaValue: string): Promise<RespuestaVerificarCaptcha> {

  const secretKey = "6Lc4wxkqAAAAAIPd22uumX_JdcMV1DkHlcz2uusL";
  const verifyUrl = 'https://endpoints.mapsys.com.ar/gestion/verificar_captcha';

  const respuesta: RespuestaVerificarCaptcha = {
    error: false,
    mensaje: '',
    captchaVerificado: false,
  };

  if (!secretKey) {
    respuesta.error = true;
    respuesta.mensaje = 'La clave secreta de reCAPTCHA no está configurada';
    return respuesta;
  }

  try {

    try {
      const response = await axios.post(verifyUrl, {
        captchaToken: captchaValue
      });     

      if (response.data.success) {
        respuesta.error = false;
        respuesta.mensaje = 'Captcha verificado correctamente';
        respuesta.captchaVerificado = true;
        return respuesta;
      } else {
        respuesta.error = true;
        respuesta.mensaje = 'Verificación de reCAPTCHA fallida: ' + response.data['error-codes'];
        respuesta.captchaVerificado = false;
        return respuesta;
      }
  
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const axiosError = error as AxiosError;
        respuesta.error = true;
        respuesta.mensaje = 'Error al verificar el captcha: ' + axiosError.message;
        if (axiosError.response) {
          respuesta.mensaje += ' - ' + axiosError.response.data;
        }
        respuesta.captchaVerificado = false;
      } else {
        respuesta.error = true;
        respuesta.mensaje = 'Error inesperado al verificar el captcha: ' + error;
        respuesta.captchaVerificado = false;
      }
      return respuesta;
    }  
} catch (error) {
    respuesta.error = true;
    respuesta.mensaje = 'Error inesperado al verificar el captcha: ' + error;
    respuesta.captchaVerificado = false;
    return respuesta;
}
};

export default VerificarCaptcha;